var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top'),_c('router-view'),(_vm.$route.name != 'Trade'&&_vm.$route.name != 'Chat'&&_vm.$route.name != 'MySelect')?_c('bottom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }